<script>
/**
 * Select component
 */
export default {
  computed: {
    validation() {
      return this.require ? this.value != "" : null;
    }
  },
  props: {
    type: {
      type: String,
      default: 'text',
    }, 
    id: {
      type: String,
    },
    rows: {
      type: Number,
      default: 5,
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: null,
    require: {
      default: false
    },
    disabled: {
      default: false
    }
  },
};
</script>
<template>
  <div class="form-group">
    <b-form-group
        class="mb-3"
        :label="$t(label)"
        :label-for="id"
      >
        <textarea
          class="form-control"
          :placeholder="placeholder == '' ? $t(label) : $t(placeholder)"
          :name="id"
          :id="id"
          :disabled="disabled"
          :rows="rows"
          :value="value" v-on:input="$emit('input', $event.target.value)"
          :state="validation"
        ></textarea>
        <b-form-invalid-feedback v-show="require" :state="validation">
          <span>{{`${$t('general.please-enter')} ${$t(label)}`}}</span>
        </b-form-invalid-feedback>
      </b-form-group>
  </div>
</template>